module.exports = __webpack_public_path__ + "img/banner-develop.0a5589ff.jpg";